export enum BookingStatus {
    Unknown = 'Unknown',
    Canceled = 'Canceled',
    Rejected = 'Rejected',
    Requesting = 'Requesting',
    PickingUp = 'Picking Up',
    OnTrip = 'On Trip',
    Arrived = 'Arrived',
    WaitingForPassenger = 'Waiting For Passenger',
    WaitingExtended = 'Extended',
    Completed = 'Completed',
    Assigned = 'Assigned',
	Unallocated = 'Unallocated',
	Accepted = 'Accepted'
}

export enum WalletCommerceTransactions {
    Paid = 'Paid',
    Failed = 'Failed - Insufficient Funds',
    Overdue = 'Overdue',
    Penalty = 'Penalty'
}
